import { Injectable, Renderer2 } from '@angular/core';
import { BaseSite, Language } from '@boels/models';

@Injectable({
  providedIn: 'root',
})
export class LinksService {
  setAttributes(
    renderer: Renderer2,
    link: HTMLLinkElement,
    attrs: { [key: string]: string },
  ): void {
    for (const key in attrs) {
      if (renderer) {
        renderer.setAttribute(link, key, attrs[key]);
      }
    }
  }

  urlBuilder(...url: string[]): string {
    let res = '';
    url.filter(Boolean).forEach((subUrl) => {
      if (subUrl !== '/') {
        if (subUrl.startsWith('/') || res.endsWith('/') || res === '') {
          res = res + subUrl;
        } else {
          res = res + '/' + subUrl;
        }
      }
    });

    return res;
  }

  cultureBuilder(baseSite?: BaseSite, language?: Language): string {
    return (
      language?.isocode?.substring(0, 2) +
      '-' +
      baseSite?.uid
        ?.split('')
        .filter((letter) => letter.match(/[A-Z]/))
        .join('')
        .toLowerCase()
    );
  }
}
